import { createRouter, createWebHistory } from 'vue-router'
import { routes } from "./routes"
import { useAuthStore } from "@/stores/auth"

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes, /* eslint-disable */
  scrollBehavior(to, from, savedPosition) {
   
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
   
   
  },
})
// nasna
router.beforeEach(async (to, from, next) => {
  
  // if(to.fullPath.includes("?CGMSISDN="))
  // { 
  //   return next({ name: 'subscribe_ok',params:{
  //     phoneNumber:to.query.CGMSISDN,
  //     cgstatus:to.query.CGSTATUS,
  //     pubId:to.query.pubID,
  //     clickId:to.query.clickID
  //      }})
  // }

  if (to.fullPath.includes("?CGMSISDN=")) {
  const queryKeys = Object.keys(to.query);
    const user_id = to.query.user_id;

  // Find the key that starts with "click" (case-insensitive)
  const clickKey = queryKeys.find(key => key.toLowerCase().startsWith("ggclick"));
  
  // Use the found key to get the value
  const clickValue = clickKey ? to.query[clickKey] : null;
  //console.log("clickValue: ", clickValue);
  return next({
    name: 'subscribe_ok',
    params: {
      phoneNumber: to.query.CGMSISDN,
      cgstatus: to.query.CGSTATUS,
      pubId: to.query.pubID,
      clickId: clickValue,
      user_id: user_id,
      // Pass the value of the case-insensitive "click" key
    }
  });
}


  const user = localStorage.getItem("user");

  if (to.name === 'subscribe_ok') {
    var phone = to.params.phoneNumber.substring(to.params.phoneNumber.indexOf('=') + 1);
    var cgstatus = to.params.cgstatus.substring(to.params.cgstatus.indexOf('=') + 1);
    var pubId = to.params.pubId?.substring(to.params.pubId?.indexOf('=') + 1);
    var clickId = to.params.clickId?.substring(to.params.clickId?.indexOf('=') + 1);
    var user_id = to.params.user_id?.substring(to.params.user_id?.indexOf('=') + 1);
    //console.log("clickId: ", clickId);
    var data = {
      phone: phone,
      cgstatus: cgstatus,
      pubId: pubId,
      clickId: clickId, 
      user_id: user_id
    }
    const auth = useAuthStore();
    await auth.checkSubescriptionStatus(data);
    return next();
  }

  if (to.meta.auth && user === null) {
    return next({ name: 'subscribe.header' });
  }

  if (to.meta.auth && user !== null) {
    return next();
  }

  if (to.meta.auth === false) {
    return next();
  }

  next();
});



export default router